const PATH = '/macro';

export default {
    async getSocialTrend() {

        return axios.get(`${PATH}/social/trend`);
    }
}
